import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getAccountRequest = {};
var _getAccountResponse = {};
var _getPayableCurrenciesRequest = {};
var _getPayableCurrenciesResponse = {};
function resolveWixPaymentApiPayV2AccountServiceUrl(opts) {
    var domainToMappings = {
        'cashier-services._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'difm._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'invoices._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'ecom._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.cartscheckout.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cartscheckout.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cartscheckout._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'progallery._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '',
            },
        ],
        'progallerycdn._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '',
            },
        ],
        'scheduler._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'events._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'bookings.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cashier._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'ecom.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'cashier.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '',
                destPath: '',
            },
        ],
        'vod-server._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'vod.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.wixhotels.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'test-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/payments',
                destPath: '/api/merchant',
            },
            {
                srcPath: '/payments/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
            {
                srcPath: '/api/plugin/v1/transactions',
                destPath: '/api/plugin/v1/transactions',
            },
            {
                srcPath: '/payments/api/merchant',
                destPath: '/api/merchant',
            },
        ],
        'us-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'eu-applepay.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'payments-sb.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/ambassador/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        _: [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
            {
                srcPath: '/payments/psp/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'tpa.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
        ],
        'pricing-plans.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/lib-mbapi/include/modules/gateway/return/paypal.php',
                destPath: '/api/payPal/payments/legacy-ipn-to-ignore',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/.well-known/apple-developer-merchantid-domain-association',
                destPath: '/domain-verification/apple-pay',
            },
        ],
        'payment-webhooks.wixapps.net': [
            {
                srcPath: '/cashier/accounts/stripe',
                destPath: '/api/merchant/stripe',
            },
            {
                srcPath: '/cashier/transactions/stripe',
                destPath: '/api/stripe',
            },
        ],
        'cashier-services.wixapis.com': [
            {
                srcPath: '/payments/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'currency-converter.wixapps.net': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
            {
                srcPath: '/payments/psp/v1/provider-platform-events',
                destPath: '/payments/v1/provider-platform-events',
            },
        ],
        'challenger.wixapps.net': [
            {
                srcPath: '/payment-services-web',
                destPath: '',
            },
            {
                srcPath: '/_api/payment-services-web',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns information about cashier account by its accountId (`appDefId:appInstanceId`) */
export function get(payload) {
    var _a = serializer(_getAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAccountResponse, {}).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.account',
            method: 'GET',
            methodFqn: 'wix.payment.api.pay.v2.AccountService.Get',
            url: resolveWixPaymentApiPayV2AccountServiceUrl({
                protoPath: '/api/payments/v2/accounts/{accountId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
/** Get list of payable currencies for current metasite */
export function getPayableCurrencies(payload) {
    var _a = serializer(_getPayableCurrenciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPayableCurrenciesResponse, {}).fromJSON;
    function __getPayableCurrencies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.pay.v2.account',
            method: 'GET',
            methodFqn: 'wix.payment.api.pay.v2.AccountService.GetPayableCurrencies',
            url: resolveWixPaymentApiPayV2AccountServiceUrl({
                protoPath: '/api/payments/v2/accounts/payable-currencies',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPayableCurrencies.fromReq = fromReq;
    __getPayableCurrencies.__isAmbassador = true;
    return __getPayableCurrencies;
}
//# sourceMappingURL=http.impl.js.map